import { render, staticRenderFns } from "./EventDetailsSeatSelection.vue?vue&type=template&id=37bce4c9&scoped=true&"
import script from "./EventDetailsSeatSelection.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsSeatSelection.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsSeatSelection.vue?vue&type=style&index=0&id=37bce4c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bce4c9",
  null
  
)

export default component.exports